import {isEmpty} from 'lodash'
import {rolesBulkEdit, getPermissionsList} from '@/libs/api/api'
import constants from '@/libs/constant/constants';
import {message ,loader} from '@/libs/helper';

export default {
    name: 'BulkUpdate',
    // mixins: [bulkUpload],
    props: {
        markedTableItems: {
            type: Array,
            default: () => {}
        },
        tableData: {
            type: Array,
            default: () => {}
        },
        organsiationID: {
            type: String,
            default: () => ''
        },
        markedTableItemsNames: {
            type: Array,
            default: () => {}
        }
    },
    computed: {
        table () {
            return this.tableData.filter(item => {
                if (new Set(this.markedTableItems).has(item._id)) return true
            })
        },
        params() {
            return `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
        },
    },
    mounted() {
        this.fetchAllPermissions()
    },
    data() {
        return {
            isEmpty,
            addToSet: false,
            limit: 50,
            skip: 0,
            sort: 'group_name',
            order: 'asc',
            groupIdName: '',
            tableDataCount: null,
            permissionsList: [],
            pageSize: 10,
            permissionsTableSettings: {
                headings: {
                    permissions_checkbox_all: 'permissions_checkbox_all',
                    permission: 'Permission name',
                    type: 'Type'
                },
                pagination: { show: true},
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                perPageValues:[]
            },
            columns: ['permissions_checkbox_all', 'permission', 'type'],
            selectedEntries: [],
            selectedPermissionNames: [],
            isAllPerissionsMarked: false,
            previousPage : 1,
            currentPage: 1,
            step: 1,
            isFinal: false,
            isProgress: false,
            isConfirm: false,
            progress: 0,
        }
    },
    methods: {
        async fetchAllPermissions(){
            loader(this, true)
            let body = {searchText: ''}
            await getPermissionsList(this.params, body).then((res) => {
                this.tableDataCount = res.result.total_count
                this.permissionsList = res.result.items.map((permission) => {
                    return {
                        _id: permission._id,
                        permission: permission.permission_name,
                        type: permission.permission_type,
                        isdefault: permission.isdefault === true ? true : false,
                    }
                })
                loader(this, false)
            })
            .catch((err) => {
                loader(this, false)
                message(this, constants.messageType.ERROR, (err))
            })
        },
        handleCheckBoxSelectPermission(id, permission_name) {
            if (!this.selectedEntries.includes(id)) {
                this.selectedEntries.push(id)
                this.selectedPermissionNames.push(permission_name)
            } else {
                const index = this.selectedEntries.indexOf(id)
                const nameIndex = this.selectedPermissionNames.indexOf(permission_name)
                if (index > -1) {
                    this.selectedEntries.splice(index, 1);
                }
                if (nameIndex > -1) {
                    this.selectedPermissionNames.splice(nameIndex, 1)
                }
            }
        },
        toggleAllForPermissions(event) {
            this.isAllPerissionsMarked = event
            if (this.isAllPerissionsMarked) {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (!row.isdefault && this.searchValue !== row._id && index === -1) {
                        this.selectedEntries.push(row._id)
                        this.selectedPermissionNames.push(row.permission)
                    }
                })
            } else {
                this.$refs.setsTable.data.map((row) => {
                    const index = this.selectedEntries.indexOf(row._id)
                    if (index > -1 && !row.isdefault) {
                        this.selectedEntries.splice(index, 1);
                        this.selectedPermissionNames.splice(row.permission)
                    }
                })
            }
        },
        confirmButton() {
            this.isProgress = true 
            this.progress = 15
            let body = {
                role_id: this.markedTableItems,
                organisation_id: this.organsiationID,
                permission_id: this.selectedEntries,
                addToSet: this.addToSet
            }
            rolesBulkEdit(body).then((res) => {  
                this.progress= 100  
                message(this, constants.messageType.SUCCESS, (res.message))
                this.step = 3
                this.isFinal = true
            }).catch(error=>{
                message(this, constants.messageType.ERROR, (error.message))
                this.isProgress = false
            })
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            // call api and and set updated data
            this.fetchAllPermissions()
        },
        buttonAction (type) {
            switch (type) {
                case 'back':
                    this.step = 1
                    this.isConfirm = false
                    break
                case 'cancel':
                    this.$emit('close')
                    break
                case 'next':    
                    if (!isEmpty(this.selectedEntries)) {
                        this.step = 2
                        this.isConfirm = true
                    }
                    break
                case 'done':
                    this.$emit('refreshPage')
                    this.$emit('close')
                    break    
            }
        },
    }
}